import * as Scrivito from "scrivito"
import { ScrivitoLink } from "scrivito/scrivito-link/ScrivitoLink"
import { IconSize } from "shared/types/Icon"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { ContactDetailsView } from "widgets/contact-details/ContactDetailsView"

import {
  ContactDetailsWidget,
  ContactDetailsWidgetDisplayMode
} from "./ContactDetailsWidgetClass"

Scrivito.provideComponent(ContactDetailsWidget, ({ widget }) => {
  const displayMode = widget.get(
    "displayMode"
  ) as ContactDetailsWidgetDisplayMode
  const contactDetails = widget.get("contactDetails")
  const telephone = contactDetails?.get("telephone") as
    | Scrivito.Link
    | undefined
  const emailAddress = contactDetails?.get("email") as Scrivito.Link | undefined
  const isEditing = Scrivito.isInPlaceEditingActive()

  return (
    <ContactDetailsView
      displayMode={displayMode}
      name={
        contactDetails?.get("name") || isEditing ? (
          <Scrivito.ContentTag content={contactDetails} attribute="name" />
        ) : null
      }
      street={
        contactDetails?.get("street") || isEditing ? (
          <Scrivito.ContentTag content={contactDetails} attribute="street" />
        ) : null
      }
      city={
        contactDetails?.get("city") || isEditing ? (
          <Scrivito.ContentTag content={contactDetails} attribute="city" />
        ) : null
      }
      country={
        contactDetails?.get("country") || isEditing ? (
          <Scrivito.ContentTag content={contactDetails} attribute="country" />
        ) : null
      }
      telephone={
        contactDetails?.get("telephone") || isEditing ? (
          <ScrivitoLink className="link" to={telephone}>
            {telephone?.title()}
          </ScrivitoLink>
        ) : null
      }
      fax={
        contactDetails?.get("fax") || isEditing ? (
          <Scrivito.ContentTag content={contactDetails} attribute="fax" />
        ) : null
      }
      email={
        emailAddress || isEditing ? (
          <ScrivitoLink className="link" to={emailAddress}>
            {emailAddress?.title()}
          </ScrivitoLink>
        ) : null
      }
      mapsURL={
        contactDetails?.get("mapsURL") || isEditing ? (
          <ScrivitoLink
            className="link"
            to={contactDetails?.get("mapsURL")}
            target="_blank"
          >
            {(contactDetails?.get("mapsURL") as Scrivito.Link)?.title()}
          </ScrivitoLink>
        ) : null
      }
      website={
        contactDetails?.get("website") || isEditing ? (
          <>
            <Icon size={IconSize.XS} name={IconName.OPEN} />
            <ScrivitoLink
              className="link"
              to={contactDetails?.get("website")}
              target="_blank"
            >
              {contactDetails?.get("website")}
            </ScrivitoLink>
          </>
        ) : null
      }
    />
  )
})
